import { filterVisibleDeals } from '@/lib/procurementVisibility';

function accountKey(deal) {
  return `${String(deal?.account_name || deal?.institution || '').trim()}|${String(deal?.country || '').trim()}`;
}

/**
 * Rows for the Contract Intelligence table.
 * Visibility (and any other predicate already applied by the caller) runs on the
 * full collection. One account per row, then the caller paginates.
 * A selected country keeps every matching deal.
 */
export function dealsToTableRows(deals, { selectedMapCountry = null } = {}) {
  const visible = filterVisibleDeals(deals);
  if (selectedMapCountry) return visible;
  const seen = new Set();
  const rows = [];
  for (const deal of visible) {
    const key = accountKey(deal);
    if (seen.has(key)) continue;
    seen.add(key);
    rows.push(deal);
  }
  return rows;
}

/** Page over an already-filtered row list. */
export function sliceTablePage(rows, page, pageSize) {
  const size = Math.max(1, Number(pageSize) || 1);
  const start = (Math.max(1, Number(page) || 1) - 1) * size;
  return (Array.isArray(rows) ? rows : []).slice(start, start + size);
}
